import { Typography } from '@gds/Typography/Typography';

import styles from './FeatureLists.module.css';

export const FeatureLists = ({
  features,
  featureHeader,
  isHtmlList,
}: {
  features: string[];
  featureHeader?: string;
  isHtmlList?: boolean;
}) => {
  return (
    <>
      {featureHeader && (
        <Typography variant="body1" className={styles.featureHeader}>
          {featureHeader}
        </Typography>
      )}
      <ul className={styles.featureLists}>
        <>
          {isHtmlList ? (
            // @ts-expect-error - Typography expects content
            <Typography
              dangerouslySetInnerHTML={{
                // eslint-disable-next-line @typescript-eslint/naming-convention
                __html: features[0],
              }}
              Component="div"
            />
          ) : (
            features.map((item, idx) => (
              <li key={idx}>
                <Typography>{item}</Typography>
              </li>
            ))
          )}
        </>
      </ul>
    </>
  );
};
